import { jsx } from 'react/jsx-runtime.js';
import Radio from '@jetbrains/ring-ui/dist/radio/radio.js';
import { Theme } from '../ThemeContext.js';
import { ThemeView } from './components/ThemeView/ThemeView.js';
import styles from './ThemeSelect.module.css.js';

var ThemeSelect = function ThemeSelect(props) {
  var theme = props.theme,
    onThemeChange = props.onThemeChange;
  var allThemes = Object.values(Theme);
  var onChangeHandler = function onChangeHandler(value) {
    onThemeChange(value);
  };
  return jsx("div", {
    className: styles.container,
    children: jsx(Radio, {
      className: styles.radioButton,
      value: theme,
      onChange: onChangeHandler,
      children: allThemes.map(function (theme) {
        return jsx(Radio.Item, {
          value: theme,
          children: jsx(ThemeView, {
            theme: theme
          })
        }, theme);
      })
    })
  });
};

export { ThemeSelect };
